import { Sparkles } from "lucide-react";

import type { Notification, NotificationConfigContext } from "../types";
import { NotificationObjectMosaic } from "./NotificationObjectMosaic";

export function NotificationNotableView({
  notifications,
  context,
  hasNextPage,
  isFetchingNextPage,
  isLoading,
  onFetchNextPage,
  onOpenAll,
}: {
  notifications: Notification[];
  context: NotificationConfigContext;
  index: number;
  onIndex: (next: number) => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  isLoading?: boolean;
  onFetchNextPage?: () => void;
  onOpenAll: () => void;
}) {
  return (
    <NotificationObjectMosaic
      notifications={notifications}
      context={context}
      hasNextPage={hasNextPage}
      isFetchingNextPage={!!isFetchingNextPage}
      isLoading={!!isLoading}
      onFetchNextPage={onFetchNextPage ?? (() => {})}
      empty={
        <div className="flex flex-col items-center justify-center px-6 py-14">
          <div className="mb-5 flex size-12 items-center justify-center rounded-xl bg-muted/80 ring-1 ring-inset ring-border/50">
            <Sparkles className="size-5 text-muted-foreground" aria-hidden />
          </div>
          <p className="text-sm font-normal text-foreground">All clear</p>
          <p className="mt-1 max-w-[18rem] text-center text-sm font-normal leading-relaxed text-muted-foreground">
            Failures and unusual changes will surface here when they need your attention.
          </p>
          <button
            type="button"
            onClick={onOpenAll}
            className="mt-4 rounded-full bg-foreground/10 px-4 py-1.5 text-xs font-medium text-foreground/80 transition-colors duration-150 hover:bg-foreground/15"
          >
            View all updates
          </button>
        </div>
      }
    />
  );
}
